module.exports = __webpack_public_path__ + "img/Screenshot-13.6d76d86e.png";